<template>
  <div>
    <Header></Header>
    <contact-us></contact-us>
    <Footer class="footer"></Footer>
  </div>
</template>
<script>
import contactUs from "../../components/contactUs";
export default {
  components: {
    contactUs,
  },
};
</script>
<style lang="scss" scoped>
.footer {
  border-top: 0px solid #000;
  @media (max-width: 768px) {
    border-top: 1px solid #000;
  }
}
</style>